import * as Highcharts from "highcharts";

export const chartData = {
  credits: { enabled: false },
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: "pie"
  },
  title: {
    useHTML: true,
    text: "<strong></strong><br/>Failed OTIF orders",
    align: "center",
    verticalAlign: "middle",
    y: -10
  },
  legend: {
    itemStyle: {
      color: "#6b778c",
      "font-weight": "normal"
    }
  },
  tooltip: {
    useHTML: true,
    headerFormat: '<table style="min-width:80px">',
    pointFormat:
      "" +
      '<tr><td style="text-transform: capitalize; color: #ffffff; padding: 0px;">{point.name} </td>' +
      '<td style="text-align: right; color: #ffffff;  padding: 0px;"><b>{point.percentage:.1f}%</b>' +
      "</td></tr>" +
      "<tr><td style='text-transform: capitalize; color: #ffffff; padding: 0px;'>Quantity</td>" +
      '<td style="text-align: right; color: #ffffff; padding: 0px;"><b>{point.y}</b>' +
      "</td></tr>",
    footerFormat: "</table>"
  },
  plotOptions: {
    pie: {
      colors: ["#EBC844", "#73C8B1", "#F4902D"],
      dataLabels: { enabled: false },
      showInLegend: true
    }
  },
  series: [
    {
      type: "pie",
      name: "Failed",
      innerSize: "70%",
      data: [["On schedule", 300], ["Delayed in network", 30], ["Delayed by consignee", 30]]
    }
  ]
};
